import { render, staticRenderFns } from "./seccionLecheros.vue?vue&type=template&id=38e6b1d4"
import script from "./seccionLecheros.vue?vue&type=script&lang=js"
export * from "./seccionLecheros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports